import { useRuntime } from './useRuntime';

export const useBrand = () => {
  const { brand } = useRuntime();

  return brand;
};
